import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "href", "linkComponent", "searchResultId", "onSelect", "onHighlighted", "onContextMenu"];
import React from 'react';
import { ResultLink } from './search-result.styled';
import { useKeyboardHighlighting } from './use-keyboard-navigation';
/**
 * This component is intended to be used as a wrapper around
 * search result content. The purpose of this component is to:
 *  - Wrap the content in a default <a></a> tag (can be overriden)
 *  - Provide keyboard shortcuts and higlighting
 *
 * The styles of this component has been designed to be as least restrictive
 * as possible. The only opinion it makes is that results are displayed as a
 * list. We may consider adding a styles override in the future.
 */
export var SearchResultLink = function SearchResultLink(_ref) {
  var children = _ref.children,
    href = _ref.href,
    linkComponent = _ref.linkComponent,
    searchResultId = _ref.searchResultId,
    onSelect = _ref.onSelect,
    onHighlighted = _ref.onHighlighted,
    onContextMenu = _ref.onContextMenu,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useKeyboardHighlight = useKeyboardHighlighting({
      searchResultId: searchResultId,
      onHighlighted: onHighlighted
    }),
    isKeyboardHighlighted = _useKeyboardHighlight.isKeyboardHighlighted,
    ref = _useKeyboardHighlight.ref;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    React.createElement("div", {
      ref: ref,
      onClick: onSelect,
      onContextMenu: onContextMenu,
      role: "none"
    }, /*#__PURE__*/React.createElement(ResultLink, _extends({
      linkComponent: linkComponent,
      href: href
    }, rest), children(isKeyboardHighlighted)))
  );
};